import React, { useState } from 'react';
import { Button, Modal } from 'antd';

export const MyModal = ({ log }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Button type="primary" onClick={showModal}>
                查看日志
            </Button>
            <Modal title="日志" width={800} destroyOnClose={true} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <pre>{log}</pre>
            </Modal>
        </>
    );
};
